// import { BASE_URL } from '@/api/url';
// import BaseFuncApi from '@/api/base/commonFunc-api';
// import Enum from '@/enum/enum';
import UserClient from '@/api/user/user-client';
const userClient = new UserClient();
export default {
    loginUser: async function (context, payload) {
        var result = await userClient.postAsync({
            url: `${userClient.url}/login-with-local`,
            data: payload
        }, true);
        if (result && result.access_token) {
            context.commit('updateUserLogin', { ...result, UserName: payload.username });
            return result;
        }
        return result;
    },


    logoutUser: async function (context, payload) {
        var result = await userClient.getAsync({
            url: `${userClient.url}/me/logout`,
        }, true);
        if (result.data && result.status && result.status === "success") {
            context.commit('updateUserId', result.data);
            return result.data;
        }
        return result;
    },

    registerUser: async function (context, payload) {
        var result = await userClient.postAsync({
            url: `${userClient.url}/register`,
            data: payload
        }, true);
        if (result.status === "success") {
            return true;
        }
        return false;
        return true
    },


    registerConsult: async function (context, payload) {
        var result = await userClient.postAsync({
            url: `${userClient.url}/consultant`,
            data: payload
        }, true);
        if (result.status || result.statusCode == 201) {
            return true;
        }
        return false;
    },

    uploadFileBase64: async function (context, payload) {
        let token = localStorage.getItem('Jwt');
        var result = await userClient.postAsync({
            url: `${userClient.url}/files-content/upload`,
            data: payload,
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
            }
        }, true);

        if (result && result.code === 200 && result.data) {
            return result.data;
        }
        return [];
    },

    createUser: async function (context, payload) {
        var result = await userClient.postAsync({
            url: `${userClient.url}`,
            data: payload
        }, true);
        if (result) {
            return result;
        }
        return null;
    },

    updateUser: async function (context, payload) {
        var result = await userClient.putAsync({
            url: `${userClient.url}`,
            data: payload
        }, true);
        if (result) {
            return result;
        }
        return null;
    },

    getUser: async function (context, payload) {
        var result = await userClient.getAsync({
            url: `${userClient.url}/${payload.id}/detail`,
            data: payload
        }, true);
        if (result && result.data) {
            return result.data;
        }
        return null;
    },

    getDetailInfos: async function (context, payload) {
        var result = await userClient.postAsync({
            url: `${userClient.url}/detail-info`,
            data: payload
        }, true);
        if (result && result.data) {
            return result.data;
        }
        return null;
    },

    createExtraMenu: async function (context, payload) {
        var result = await userClient.postAsync({
            url: `${userClient.url}/extra-menu`,
            data: payload
        }, true);
        if (result && result.data) {
            return result.data;
        }
        return null;
    },

    enableExtraMenu: async function (context, payload) {
        var result = await userClient.putAsync({
            url: `${userClient.url}/extra-menu/${payload.id}`,
            data: payload
        }, true);
        if (result) {
            return result;
        }
        return null;
    },

    getExtraMenus: async function (context, payload) {
        var result = await userClient.getAsync({
            url: `${userClient.url}/extra-menu/gets`,
            data: payload
        }, true);
        if (result && result.data) {
            return result.data;
        }
        return null;
    },

    getUsers: async function (context, payload) {
        var result = await userClient.getAsync({
            url: `${userClient.url}/search`,
            queries: payload
        }, true);
        if (result && result.data) {
            context.commit("updateTotalPage", result.data);
            return result.data;
        }
        return null;
    },

    deleteUser: async function (context, payload) {
        var result = await userClient.putAsync({
            url: `${userClient.url}/${payload.id}/enable?enabled=false`,
        }, true);
        return result;
    },
}